module.exports = __webpack_public_path__ + "media/images/item/gt-cd3d2d84d36214c91b46e92447649665.gif";